export const environment: string = globalThis.environment || 'prod';
export const deployment: string = globalThis.deployment || null;
export const devServer: boolean = globalThis.devServer || false;
export const prod = environment === 'prod' || environment === 'production';
export const LEGACY_NGINX_IP = prod ? '104.198.16.142' : '104.197.128.105';
export const DEFAULT_NGINX_IP = prod ? '104.154.100.138' : '35.224.127.236';
export const WSP_SITE_EXTERNAL_IP = prod ? '34.149.86.124' : '34.102.245.214';
export const WSP_MS_SITE_EXTERNAL_IP = prod ? '35.227.228.214' : '34.107.173.170';
